import React, { RefCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { CloseButton } from 'craft/components/CloseButton';
import Node from 'craft/components/Node';
import { setScrollableBodyDom } from 'craft/state';

export const TOOLTIP_BODY_ID = 'tooltip-body-container';

interface Props {
  children: React.ReactNode;
  nodeId: string;
  isDismissible: boolean;
  wrapperRef?: RefCallback<HTMLDivElement>;
  wrapperCss?: any;
  arrowRef?: RefCallback<HTMLDivElement>;
  arrowCss?: any;
  bodyCss?: any;
  classNameObj: Record<string, string>;
}

export const HotspotTooltip = ({
  children,
  nodeId,
  isDismissible,
  wrapperRef,
  wrapperCss,
  arrowRef,
  arrowCss,
  bodyCss = {},
  classNameObj: CLASS_NAME,
}: Props) => {
  const dispatch = useDispatch();
  const bodyRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    // save document root's scrollable body ref to the store
    dispatch(setScrollableBodyDom(bodyRef));
  }, []);

  return (
    <div
      id={`tooltip-wrapper-${nodeId}`}
      ref={wrapperRef}
      className={CLASS_NAME.Wrapper}
      css={wrapperCss}
      style={{ position: 'absolute', zIndex: 3 }}
    >
      <div ref={arrowRef} className={CLASS_NAME.Arrow} css={arrowCss} />
      <Node is="div" className={CLASS_NAME.Container} css={{ outline: 'none' }}>
        {isDismissible && <CloseButton />}
        <div
          id={TOOLTIP_BODY_ID}
          ref={(dom: any) => {
            bodyRef.current = dom;
          }}
          className={CLASS_NAME.Body}
          style={bodyCss}
        >
          {children}
        </div>
      </Node>
    </div>
  );
};
